console.log("CEK-BUNDLE-OK-777");
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from '@/pages/HomePage';
import RaceDetailPage from '@/pages/RaceDetailPage';
import RacesPage from '@/pages/RacesPage';
import SchedulePage from '@/pages/SchedulePage';
import ResultsPage from '@/pages/ResultsPage';
import ContactPage from '@/pages/ContactPage';
import Layout from '@/components/Layout';
import { Toaster } from '@/components/ui/toaster';
import ScrollToTop from '@/components/ScrollToTop';

function App() {
  return (
    <>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/races" element={<RacesPage />} />
          <Route path="/race/:raceId" element={<RaceDetailPage />} />
          <Route path="/schedule" element={<SchedulePage />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </Layout>
      <Toaster />
    </>
  );
}

export default App;